export const EDITION = "EDITION";
export const READ_ONLY = "READ_ONLY";
